import styled from 'styled-components';

export const Box = styled.div`
  max-width: 320px;
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 768px) {
    max-width: 480px;
    padding: 48px 48px;
  }
`;

export const Btn = styled.button`
  margin-top: 20px;
  padding: 14px 32px;
  border: none;
  border-radius: ${props => props.theme.radii.pill};
  font-family: ${props => props.theme.fonts.body};
  font-weight: 600;
  font-size: 14px;
  color: ${props => props.theme.colors.textPrimary};
  background: ${props => props.theme.colors.secondary};
  cursor: pointer;
  transition: ${props => props.theme.transition.main};

  &:hover,
  &:focus-visible {
    background: ${props => props.theme.colors.hoverColor};
  }

  @media (min-width: 768px) {
    margin-top: 28px;
    padding: 16px 44px;
    font-size: 16px;
  }
`;
